// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { isCanada } from '@tcp/core/src/utils';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty.js';
import withStyles from '../../../../../../common/hoc/withStyles';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Button from '../../../../../../common/atoms/Button';
import TextBox from '../../../../../../common/atoms/TextBox';

import createValidateMethod from '../../../../../../../utils/formValidation/createValidateMethod';
import getStandardConfig from '../../../../../../../utils/formValidation/validatorStandardConfig';
import styles from '../styles/ZipcodeForm.style';

import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblZipCode,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import {
  GlobalActionsLabels,
  GLOBAL_ACTIONS_LABELS,
  lblSubmit,
} from '../../../../../../../utils/labels/globalActions.labels';

class ZipcodeForm extends React.PureComponent {
  render() {
    const { className, handleSubmit, onChangeForm, invalid, onSubmit, checkoutLabels } = this.props;
    const handleKeypress = (event) => {
      if (event?.key === 'Enter' || event?.keyCode === 13) {
        document.getElementById('zip_code_btn').click();
      }
    };
    return (
      <form name="zipcode-form" onChange={onChangeForm} className={`${className} elem-mb-XS`}>
        <BodyCopy component="div" className="zip-code-field">
          <Field
            id="postalCode"
            placeholder={
              isCanada()
                ? checkoutLabels.lbl_estimated_zip_placeholder_ca
                : getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblZipCode}`,
                    GlobalGenericLabels
                  )
            }
            name="postalCode"
            component={TextBox}
            dataLocator="zipcode"
            errorDataLocator="zipcode_error_msg"
            showSuccessCheck={false}
            enableSuccessCheck={false}
            className="elem-mb-L"
            onKeyPress={(event) => {
              handleKeypress(event);
            }}
            maxLength={isCanada() ? 7 : 5}
            spc
          />
        </BodyCopy>
        <BodyCopy component="div" textAlign="center">
          <Button
            id="zip_code_btn"
            fill="BLUE"
            type="button"
            buttonVariation="fixed-width"
            dataLocator="zip_code_btn"
            disabled={invalid}
            className="elem-mb-L zip-code-cta"
            onClick={handleSubmit(onSubmit)}
          >
            {getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblSubmit}`,
              GlobalActionsLabels
            )}
          </Button>
        </BodyCopy>
      </form>
    );
  }
}

ZipcodeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onChangeForm: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};

const validateMethod = createValidateMethod(getStandardConfig(['postalCode', 'zipcode-form']));

export default reduxForm({
  form: 'zipcode-form', // a unique identifier for this form
  enableReinitialize: true,
  ...validateMethod,
})(withStyles(ZipcodeForm, styles));
export { ZipcodeForm as ZipcodeFormVanilla };
